export default __webpack_public_path__ + "static/media/reports-14.badc100a.png";